export default __webpack_public_path__ + "static/天下第一配音徵選_BN-124dd881557954d2f0c0a5ac138a3153.png";